import React, { useRef } from "react";
import { BsFillMegaphoneFill } from "react-icons/bs";
import helpers from "utils/helpers";

export default function AnnouncementMarquee({ announcementData }) {
  const marqueeRef = useRef(null);

  const pause = () => {
    if (marqueeRef.current?.stop) marqueeRef.current.stop();
  };

  const resume = () => {
    if (marqueeRef.current?.start) marqueeRef.current.start();
  };

  return (
    <div
      className="w-full bg-[#e7bd5c] text-black py-3 overflow-hidden fixed z-[99] top-0"
      onMouseOver={pause}     
      onMouseOut={resume}      
    >
      <div className="flex items-center gap-3 px-4">
        <BsFillMegaphoneFill className="w-5 h-5 text-black flex-shrink-0" />

        <div className="overflow-hidden w-full">
          <marquee
            ref={marqueeRef}
            direction="left"
            scrollamount="5"
            behavior="scroll"
            className="flex items-center"
          >
            <span className="font-normal">
              {helpers.capitalizeFirstWord(
                announcementData?.announcementMessage
              )}
            </span>
          </marquee>
        </div>
      </div>
    </div>
  );
}
